<template>
  <div class="rounded-md bg-black p-2 shadow-md lg:p-4">
    <div class="relative grid">
      <Skeleton class="aspect-[9/16]" />
    </div>
    <div class="pt-4">
      <div class="flex items-center justify-between gap-4 lg:gap-8">
        <div class="w-full">
          <Skeleton class="mb-4 h-4 lg:w-[200px]" />
          <Skeleton class="h-4 lg:w-[250px]" />
        </div>
        <Skeleton class="h-10 w-10 flex-shrink-0 rounded-full" />
      </div>
      <Skeleton class="mt-4 h-4 pb-3" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from '@ui/skeleton/Skeleton.vue';
</script>
